;(function(){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = {
  name: "AgentFloatBalance",
  data: function data() {
    return {
      todays_earnings: 0,
      float_balance: 0,
      all_time_earnings: 0,
      consumer_secret: null,
      consumer_key: null,
      merchant_id: null,
      float_account_id: null,
      agent_current_account_id: null,
      user_id: null
    };
  },
  created: function created() {
    this.consumer_secret = this.$attrs["con_secret"];
    this.consumer_key = this.$attrs["con_key"];
    this.merchant_id = this.$attrs["merchant_id"];
    this.float_account_id = this.$attrs["float_account_id"];
    this.agent_current_account_id = this.$attrs["agent_current_account_id"];
    this.user_id = this.$attrs["user_id"];

    setTimeout(this.getOauthToken, 500);
  },

  methods: {
    getOauthToken: function getOauthToken() {
      var _this = this;

      var url = "/api/oauth/generate/token";
      var payload = {
        secret: this.consumer_secret,
        key: this.consumer_key
      };

      Vue.axios.post(url, payload).then(function (response) {
        _this.api_token = response.data.token;
        _this.getStats(_this.api_token);
      }).catch(function (error) {}).then(function () {});
    },
    getStats: function getStats(token) {
      var _this2 = this;

      var url = "/api/dashboard/stats/revenues";
      Vue.axios.get(url, {
        params: {
          owner_id: this.merchant_id,
          user_id: this.user_id,
          float_account_id: this.float_account_id,
          agent_current_account_id: this.agent_current_account_id
        }
      }).then(function (response) {
        _this2.revenues = response.data;
        _this2.todays_earnings = _this2.to_human(_this2.revenues.revenue_today);
        _this2.all_time_earnings = _this2.to_human(_this2.revenues.revenue_all_time);
        _this2.float_balance = _this2.to_human(_this2.revenues.float_balance);
      }).catch(function (error) {}).then(function () {});
    },
    to_human: function to_human(x) {
      var n = x;
      return n.toLocaleString();
    }
  }
};
})()
if (module.exports.__esModule) module.exports = module.exports.default
var __vue__options__ = (typeof module.exports === "function"? module.exports.options: module.exports)
if (__vue__options__.functional) {console.error("[vueify] functional components are not supported and should be defined in plain js files using render functions.")}
__vue__options__.render = function render () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"row"},[_c('div',{staticClass:"col-12 col-lg-4 col-xl"},[_c('div',{staticClass:"card"},[_c('div',{staticClass:"card-body"},[_c('div',{staticClass:"row align-items-center"},[_c('div',{staticClass:"col"},[_c('h6',{staticClass:"text-uppercase text-muted mb-2"},[_vm._v("Today’s Earnings")]),_vm._v(" "),_c('span',{staticClass:"h2 mb-0"},[_vm._v("KES. "+_vm._s(_vm.todays_earnings))])]),_vm._v(" "),_vm._m(0)])])])]),_vm._v(" "),_c('div',{staticClass:"col-12 col-lg-4 col-xl"},[_c('div',{staticClass:"card"},[_c('div',{staticClass:"card-body"},[_c('div',{staticClass:"row align-items-center"},[_c('div',{staticClass:"col"},[_c('h6',{staticClass:"text-uppercase text-muted mb-2"},[_vm._v("All time Earnings")]),_vm._v(" "),_c('span',{staticClass:"h2 mb-0"},[_vm._v("KES. "+_vm._s(_vm.all_time_earnings))])]),_vm._v(" "),_vm._m(1)])])])]),_vm._v(" "),_c('div',{staticClass:"col-12 col-lg-4 col-xl"},[_c('div',{staticClass:"card"},[_c('div',{staticClass:"card-body"},[_c('div',{staticClass:"row align-items-center"},[_c('div',{staticClass:"col"},[_c('h6',{staticClass:"text-uppercase text-muted mb-2"},[_vm._v("Pesaflow float balance")]),_vm._v(" "),_c('span',{staticClass:"h2 mb-0"},[_vm._v("KES. "+_vm._s(_vm.float_balance))])]),_vm._v(" "),_vm._m(2)])])])])])}
__vue__options__.staticRenderFns = [function render () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"col-auto"},[_c('span',{staticClass:"h2 fe fe-dollar-sign text-muted mb-0"})])},function render () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"col-auto"},[_c('span',{staticClass:"h2 fe fe-briefcase text-muted mb-0"})])},function render () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"col-auto"},[_c('span',{staticClass:"h2 fe fe-clock text-muted mb-0"})])}]
if (module.hot) {(function () {  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), true)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-adfd3808", __vue__options__)
  } else {
    hotAPI.reload("data-v-adfd3808", __vue__options__)
  }
})()}